import { actions, mutations } from "@/store";
import { adaptUser, userManager } from "@/utils/identity";
import { removeAllUnloadListeners } from "@/utils/unloadListeners";
import { trackException } from "@/appInsights";
import { AppNotification } from "@/constants/appNotification";

export default {
  identityInit({ dispatch, commit }, initialUser) {
    commit(mutations.identityInit, initialUser && adaptUser(initialUser));
    userManager.events.addUserLoaded(user => {
      commit(mutations.userLoaded, adaptUser(user));
    });
    userManager.events.addUserUnloaded(() => {
      commit(mutations.userUnloaded);
    });
    userManager.events.addAccessTokenExpiring(async () => {
      commit(mutations.accessTokenExpiring);
      dispatch(actions.notificationAdd, {
        id: AppNotification.IdentificationTokenExpiring,
        title: "Access token expiring",
        message: "Would you like to continue working?",
        duration: 0,
        actions: [
          { action: actions.identitySignOut, label: "Logout" },
          { action: actions.identitySignInSilent, label: "Renew" }
        ]
      });
    });
    userManager.events.addAccessTokenExpired(async () => {
      commit(mutations.accessTokenExpired);
      dispatch(actions.identitySignOut);
    });
    userManager.events.addSilentRenewError(error => {
      commit(mutations.silentRenewError, error);
    });
    userManager.events.addUserSignedOut(() => {
      commit(mutations.userSignedOut);
      dispatch(actions.notificationAdd, {
        id: AppNotification.UserSignedOut,
        title: "You have been signed out",
        message: "Would you like to login again?",
        duration: 0,
        actions: [
          { label: "Dismiss" },
          { label: "Login", action: actions.identitySignOut }
        ]
      });
    });
  },
  identityError({ commit }, error) {
    commit(mutations.identityError, error);
  },
  async identitySignOut() {
    removeAllUnloadListeners();
    await userManager.signoutRedirect();
  },
  async identitySignInSilent({ dispatch }) {
    try {
      await userManager.signinSilent();
    } catch (error) {
      trackException({
        exception: error,
        properties: { source: "store/identity/identitySignInSilent" }
      });
      dispatch(actions.notificationAdd, {
        id: AppNotification.SilentSignInFail,
        title: "Silent sign-in failed",
        message: error.message,
        duration: 0,
        actions: [{ label: "Dismiss" }]
      });
    }
  }
};
